export const POPULAR_PRODUCTS_DISPLAY_LIMIT = 6
export const MANUFACTURER_DISPLAY_LIMIT = 6
